import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import ResponsiveForm from '../../Form';
import { validate } from '../../../../Helpers';
import {
  BUSINESS_TYPE_FORM as form,
  BUSINESS_TYPE_VALIDATIONS,
  EDIT_INPUTS,
} from './config';

let EditBusinessTypeForm = ({ handleSubmit, loading = false, ...props }) => (
  <ResponsiveForm
    {...props}
    inputs={EDIT_INPUTS}
    loading={loading}
    onSubmit={handleSubmit}
  />
);

EditBusinessTypeForm = reduxForm({
  form,
  validate: validate(BUSINESS_TYPE_VALIDATIONS),
})(EditBusinessTypeForm);

const mapStateToProps = ({
  businessTypes: {
    item,
  },
}) => ({
  initialValues: item ? item.data : {},
});

export default connect(
  mapStateToProps
)(EditBusinessTypeForm);
